"use client";
import "./styles.scss";
import { Empty as CEmpty } from "antd";

function Empty() {
  return (
    <div className="empty">
      <CEmpty description="Không có dữ liệu ...!" />
    </div>
  );
}

export default Empty;
